<template>
    <div
        v-if="$_job"
        class="af-jobview-content-left"
    >
        <div
            class="af-job-header afu-flex afu-box-border"
            :class="{'md:afu-flex-col afu-justify-between afu-pb-6 afu-pt-5 afu-items-start': !isApplyView, 'afu-p-5 afu-items-center afu-shadow-card': isApplyView}"
        >
            <img
                v-if="showCompanyLogo && $_job.company_square_logo_url"
                class="afu-object-contain"
                :class="{'afu-h-10 md:afu-h-16 md:afu-w-16 md:afu-pb-5': !isApplyView, 'afu-h-65 afu-w-65 afu-mr-4': isApplyView}"
                :src="$_job.company_square_logo_url"
                :alt="$_job.company_name"
                :title="$_job.company_name"
            >
            <div class="af-job-title">
                <h1
                    class=" afu-font-semibold afu-text-black"
                    :class="{'af-text--2xl afu-mb-4': !isApplyView, 'afu-text-4xl afu-mb-1 afu-font-semibold': isApplyView}"
                    v-html="$_jobTitle"
                />
                <div
                    class="af-job-features afu-flex afu-flex-col afu-text-secondary"
                    :class="{'af-text--lg afu-gap-2': !isApplyView, 'afu-text-base afu-gap-1': isApplyView}"
                >
                    <div
                        class="afu-font-semibold af-location"
                    >
                        <span
                            class="afu-hidden afu-font-semibold afu-text-secondary"
                            :class="{'af-text--base': !isApplyView, 'afu-text-base': isApplyView}"
                        >{{ $t('label.location') }}:</span>
                        <a
                            class="afu-no-underline afu-text-secondary afu-font-semibold"
                            :class="{'af-text--lg afu-gap-2': !isApplyView, 'afu-text-base': isApplyView}"
                            :href="getLocationLink"
                        > {{ $_locationLabel }} </a>
                    </div>
                    <div
                        v-if="!parseInt($_job.pay_is_hidden)"
                        class="afu-font-semibold af-pay-salary"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ $t('label.salary') }}:</span>
                        <span v-html="getMinMaxLabel"></span>
                    </div>
                    <div
                        class="afu-font-semibold af-pay-description"
                    >
                        {{ $_job.pay_description }}
                    </div>
                    <div
                        v-if="showCustomAttribute(1)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_1"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(1) }}:</span> {{ getCustomAttributeValue(1) }}
                    </div>
                    <div
                        v-if="showCustomAttribute(2)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_2"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(2) }}:</span> {{ getCustomAttributeValue(2) }}
                    </div>
                    <div
                        v-if="showCustomAttribute(3)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_3"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(3) }}:</span> {{ getCustomAttributeValue(3) }}
                    </div>
                    <div
                        v-if="showCustomAttribute(4)"
                        class="afu-font-semibold af-custom-attribute af-label-applyflow_custom_4"
                    >
                        <span class="afu-hidden afu-font-semibold afu-text-secondary af-text--base">{{ getCustomAttribute(4) }}:</span> {{ getCustomAttributeValue(4) }}
                    </div>
                </div>
            </div>
        </div>

        <MqLayout mq="sm">
            <JobViewWidgetMobile v-if="widget" />
        </MqLayout>
        <div
            class="content-bg-holder afu-bg-neutral-light afu-absolute afu-left-0 afu-w-full afu-z-0"
            id="content-bg-holder"
            v-if="!isApplyView"
        />

        <hr
            class="afu-border afu-border-custom-divider afu-my-5"
            v-if="!isApplyView"
        >
        <div
            :id="isApplyView ? 'apply-jobview-sidebar': ''"
            :class="{'afu-overflow-y-auto': scrollbar}"
        >
            <template v-if="$_job.job_bullets && $_job.job_bullets.length">
                <div
                    class="afu-pt-6 afu-pb-2"
                    :class="{'afu-pr-5 afu-pl-9 afu-text-base afu-leading-base': isApplyView}"
                >
                    <ul
                        class="afu-list-disc afu-m-0 afu-text-black afu-pl-4"
                    >
                        <li
                            v-for="(job_bullet, index) in $_job.job_bullets"
                            :key="`${$_job.uuid}_${index}`"
                            :class="{'afu-text-lg afu-leading-lg': !isApplyView, 'afu-text-base afu-leading-base': isApplyView}"
                        >
                            {{ job_bullet }}
                        </li>
                    </ul>
                </div>
            </template>
            <div
                class="af-job-desc afu-pt-0 afu-pb-5 afu-text-black afu-pt-3"
                :class="{ 'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-px-5 afu-text-base afu-leading-base' : isApplyView }"
            >
                <JobViewVideo position="A" />

                <div v-html="$_jobBody" />

                <JobViewVideo position="B" />

                <div
                    v-if="$_job.consultant_detail"
                    class="af-job-consultants afu-flex afu-mt-12 afu-text-black"
                    :class="{'afu-hidden' : isApplyView}"
                >
                    <div>
                        <h2 class="af-job-consultantsLabel afu-mb-9 af-text--3xl">
                            {{ $t('label.consultant') }}
                        </h2>
                        <div class="af-job-consultantsPortrait afu-flex afu-text-black afu-flex-row afu-items-center afu-mb-7 afu-gap-7">
                            <div
                                class="afu-flex-col af-job-consultantsImgWrp"
                                v-if="$_job.consultant_detail.profile_url"
                            >
                                <img
                                    :src="$_job.consultant_detail.profile_url"
                                    class="afu-w-full afu-rounded-btn"
                                >
                            </div>
                        </div>
                        <div class="afu-text-black af-job-consultantsDetails afu-flex afu-flex-col afu-gap-4">
                            <div
                                v-if="$_job.consultant_detail.first_name"
                                class="af-job-consultantsName"
                            >
                                <h2 class="af-text--2xl afu-text-primary-dark">
                                    {{ $_job.consultant_detail.first_name }} {{ $_job.consultant_detail.last_name }}
                                </h2>
                            </div>
                            <div
                                v-if="$_job.consultant_detail.title"
                                class="af-job-consultantsTitle"
                            >
                                <h3 class="afu-text-lg afu-leading-lg afu-text-primary-light afu-font-normal">
                                    {{ $_job.consultant_detail.title }}
                                </h3>
                            </div>
                            <div class="afu-flex-col afu-flex afu-self-stretch">
                                <div class="afu-text-black">
                                    <div
                                        v-if="$_job.consultant_detail.phone"
                                        class="afu-text-xl afu-mb-6 af-job-consultantsPhone"
                                    >
                                        <FontAwesomeIcon
                                            :icon="['fas', 'phone-alt']"
                                            class="afu-w-5 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-4"
                                        /> <a :href="'tel:' + $_job.consultant_detail.phone"><span class="afu-text-lg afu-leading-lg afu-text-primary-dark">{{ $_job.consultant_detail.phone }}</span></a>
                                    </div>
                                    <div
                                        v-if="$_job.consultant_detail.email"
                                        class="afu-text-xl afu-mb-6 af-job-consultantsEmail"
                                    >
                                        <FontAwesomeIcon
                                            :icon="['far', 'envelope']"
                                            class="afu-w-5 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-4"
                                        /><a :href="'mailto:' + $_job.consultant_detail.email"><span class="afu-text-lg afu-leading-lg afu-text-primary-dark">{{ $_job.consultant_detail.email }}</span></a>
                                    </div>
                                    <div
                                        v-if="$_job.consultant_detail.linkedin_url"
                                        class="afu-text-xl afu-mb-6 af-job-consultantsLinkedin"
                                    >
                                        <FontAwesomeIcon
                                            :icon="['fab', 'linkedin']"
                                            class="afu-w-5 afu-text-primary-dark svg-inline--fa fa-w-14 afu-mr-4"
                                        /> <a :href="$_job.consultant_detail.linkedin_url"><span class="afu-text-lg afu-leading-lg afu-text-primary-dark">{{ $_job.consultant_detail.linkedin_url }}</span></a>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="$_job.consultant_detail.blurb"
                                class="af-job-consultantsIntro afu-text-lg afu-leading-lg afu-text-primary-dark afu-font-normal"
                            >
                                {{ $_job.consultant_detail.blurb }}
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="af-job-features afu-flex afu-flex-col afu-mt-4 afu-text-black"
                    :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                >
                    <div class="afu-mb-1">
                        <span class="afu-mr-1 afu-block afu-font-semibold">{{ $t('label.reference_number') }}:</span> <span> {{ $_job.advertiser_reference }} </span>
                    </div>
                    <div
                        class="afu-flex afu-flex-col afu-mb-1"
                    >
                        <span class="afu-mr-1 afu-block afu-text-black afu-font-semibold">{{ $t('label.profession') }}:</span>
                        <div
                            v-for="(classification, index) in $_classifications"
                            :key="classification.id + index"
                            class="afu-flex"
                        >
                            <div
                                class="af-job-classification afu-text-black afu-flex afu-items-center"
                                :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                            >
                                <a
                                    class="afu-text-black afu-no-underline"
                                    :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                                    :href="getClassificationLink(classification)"
                                >{{ classification.value }}</a>
                                <div
                                    v-for="(subclassification, index_sub) in classification.subclassifications"
                                    :key="subclassification.id + index_sub"
                                >
                                    <FontAwesomeIcon
                                        :icon="['fal', 'angle-right']"
                                        class="afu-mx-1 afu-w-2 afu-text-black"
                                    />
                                    <a
                                        class="afu-text-black afu-no-underline"
                                        :class="{'afu-text-lg afu-leading-lg' : !isApplyView, 'afu-text-base afu-leading-base' : isApplyView }"
                                        :href="getSubClassificationLink(classification, subclassification)"
                                    >{{ subclassification.value }}</a>
                                    <span
                                        v-if="index_sub != Object.keys(classification.subclassifications).length - 1"
                                        class="afu-mr-2"
                                    >,</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="afu-mb-1">
                        <span class="afu-mr-1 afu-block afu-font-semibold">{{ $t('label.company') }}:</span> <span v-if="!$_isPrivateListing">{{ $_primaryCompanyName }} {{ $_companyName }}</span> <span v-else>Private Listing</span>
                    </div>
                    <div class="afu-mb-1">
                        <span class="afu-mr-1 afu-block afu-font-semibold">{{ $t('job_view.date_posted') }}:</span> <span> {{ $_postedAt | dateFormat }} </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import JobViewContentMixin from '@/apps/jobview/mixins/JobViewContentMixin';
    import Filters from '@/components/Utils/Filters';

    import JobViewWidgetMobile from './JobViewWidgetMobile';
    import JobViewVideo from './JobViewVideo';

    export default {
        name: 'JobViewContent',

        components: {
            JobViewWidgetMobile,
            JobViewVideo,
        },

        mixins: [JobViewContentMixin, Filters],

        props: {
            isApplyView: {
                type: Boolean,
                default: false,
            },

            scrollbar: {
                type: Boolean,
                default: false,
            },

            widget: {
                type: Boolean,
                default: true,
            },
        },

        mounted() {
            if(!this.isApplyView) {
                this.setHeaderBG();
            }
            if(this.isApplyView) {
                this.setSidebarHeight();
            }
        },

        methods: {
            setHeaderBG() {
                var objjs = document.getElementById('content-bg-holder');
                var objSpaceTop = objjs.offsetTop;
                document.getElementById('content-bg-holder').style.height = objSpaceTop + 'px';
                document.getElementById('content-bg-holder').style.top = '0';
            },
            setSidebarHeight() {
                window.addEventListener('load', this.adjustSidebarHeight);
                document.addEventListener('scroll', this.adjustSidebarHeight);
            },
            getSiteCode() {
                return window?.afConfig?.site_code;
            },
            adjustSidebarHeight() {
                var spaceTop = document.getElementById('apply-jobview-sidebar').getBoundingClientRect().top;
                const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
                const maxH = vh - spaceTop - 1;
                document.getElementById('apply-jobview-sidebar').style.maxHeight = maxH + 'px';
                document.getElementById('apply-jobview-sidebar').style.height = maxH + 'px';
            },
        },
    };
</script>
<style lang="scss" scoped>
.af-jobview-content > a,
.af-jobview-content .af-jobview-content-left .af-job-header > * {
    position: relative;
    z-index: 1;
}

.af-job-consultantsImgWrp {
    width: 330px;
    max-width: 330px;

    img {
        max-width: 100%;
        max-height: 300px;
        object-fit: cover;
    }
}

/* Hide scrollbar for Chrome, Safari and Opera */
#apply-jobview-sidebar {
    -ms-overflow-style: none;
    scrollbar-width: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
#apply-jobview-sidebar::-webkit-scrollbar {
    display: none;
}

.af-job-consultants a {
    text-decoration: none;
}
</style>
